$(function () {
    $('.header-dropdown').hover(function () {
        $(this).children('.dropdown-bar').addClass('dropdown-bar-hover');
        $(this).children('.dropdown-list').show();
    }, function () {
        $(this).children('.dropdown-bar').removeClass('dropdown-bar-hover');
        $(this).children('.dropdown-list').hide();
    });
});